import { expected } from '@aloft/toolkit-shared';
import { Row, Table, getSortedRowModel } from '@tanstack/react-table';

import { isPinned } from '../../../ToolkitPropertyTable/isPinned.ts';

function putPinnedFirst(rows: Row<unknown>[], rowsToPin: number) {
  return [
    ...rows.filter((r) => isPinned(rowsToPin, r.index)).sort((a, b) => a.index - b.index),
    ...rows.filter((r) => !isPinned(rowsToPin, r.index)),
  ];
}

export function getSortedRowModelWithPinnedSubject(rowsToPin: number) {
  const custom = (table: Table<unknown>) => {
    const rowModel = getSortedRowModel()(table);

    const customRows = () => {
      const { rows, flatRows, rowsById } = rowModel();
      return {
        rows: expected(putPinnedFirst(rows, rowsToPin)),
        flatRows: expected(putPinnedFirst(flatRows, rowsToPin)),
        rowsById: expected(rowsById),
      };
    };

    return customRows;
  };

  return custom;
}
